import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Voting Systems", -1)
const _hoisted_3 = { class: "table is-bordered is-striped" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "button is-danger" }, "Delete", -1)
const _hoisted_8 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (system) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: system.id
          }, [
            _createElementVNode("td", null, _toDisplayString(system.id), 1),
            _createElementVNode("td", null, _toDisplayString(system.name), 1),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `/voting-system/${system.id}`,
                  class: "button is-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _hoisted_7
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "button is-link",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createNew && _ctx.createNew(...args)), ["prevent"]))
      }, "Add New")
    ])
  ]))
}